module.exports = __webpack_public_path__ + "img/default_snapshot.557650d4.svg";